import _ from 'lodash'
import ActionEvent from '../../lib/ActionEvent'
import HttpRequest from '../../lib/HttpRequest'
import { actions as crm } from '../../../../plugins/Crm'

const api = {
  profile: new HttpRequest('user-profile'),
  user: new HttpRequest('users')
}
const actions = {
  activate ({ commit, state }) {
    return new Promise((resolve, reject) => {
      const payload = { id: state.auth.user._id }

      api.user.post('activate', payload)
        .then(({ data }) => {
          commit('auth/user', data)

          ActionEvent.$emit('auth.update-user', data)

          resolve(data)
        })
        .catch(({ response }) => reject(response.data))
    })
  },

  'assign-role': ({ commit, state }, role) => {
    return new Promise((resolve, reject) => {
      const payload = { id: state.auth.user._id, role }

      api.user.post('assign-role', payload)
        .then(({ data }) => {
          commit('auth/user', data)

          ActionEvent.$emit('auth.update-user', data)

          resolve(data)
        })
        .catch(({ response }) => reject(response.data))
    })
  },

  patch ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      payload = _.merge({ _id: state.auth.user._id }, payload)

      api.user.save(payload)
        .then(({ data }) => {
          commit('auth/user', data)

          ActionEvent.$emit('auth.update-user', data)

          resolve(data)
        })
        .catch(({ response }) => reject(response.data))
    })
  },

  refresh ({ commit, state }) {
    return new Promise((resolve, reject) => {
      api.user.get(state.auth.user._id)
        .then(({ data }) => {
          commit('auth/user', data)

          ActionEvent.$emit('auth.update-user', data)

          resolve(data)
        })
        .catch(({ response }) => reject(response.data))
    })
  },

  registry ({ commit }, user) {
    if (user.email) {
      crm.identify(user.email)

      return new Promise((resolve, reject) => {
        api.user.post('registry', user)
          .then(({ data }) => {
            commit('auth/user', data)

            resolve(data)
          })
          .catch(({ response }) => reject(response.data))
      })
    }
  },

  'request-password-change' ({ state }) {
    return new Promise((resolve, reject) => {
      api.user.post('request-password-change', { email: state.auth.user.email })
        .then(({ data }) => {
          resolve(data)
        })
        .catch(({ response }) => reject(response.data))
    })
  },

  'set-meta': ({ dispatch, state }, data) => {
    const meta = _.cloneDeep(state.auth.user.meta || {})

    if (_.isArray(data)) {
      data.forEach(({ key, value }) => _.set(meta, key, value))
    } else if (_.isPlainObject(data)) {
      _.set(meta, data.key, data.value)
    }

    return dispatch('auth/update', {
      meta
    })
  },

  sync ({ commit }) {
    return new Promise((resolve, reject) => {
      api.user.post('sync-auth')
        .then(({ data }) => {
          commit('auth/user', data)

          ActionEvent.$emit('auth.update-user', data)

          resolve(data)
        })
        .catch(({ response }) => reject(response.data))
    })
  },

  update ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      api.user.put(state.auth.user._id, payload)
        .then(({ data }) => {
          commit('auth/user', data)

          ActionEvent.$emit('auth.update-user', data)

          resolve(data)
        })
        .catch(({ response }) => reject(response.data))
    })
  },

  'update-profile': ({ commit, state }, profile) => {
    return new Promise((resolve, reject) => {
      profile._id = state.auth.user.profile._id

      api.profile.save(profile)
        .then(({ data }) => {
          const user = _.cloneDeep(state.auth.user)
          user.profile = data

          commit('auth/user', user)

          ActionEvent.$emit('auth.update-user', user)

          resolve(data)
        })
        .catch(({ response }) => reject(response.data))
    })
  },

  // TODO Check these are still required

  async authorize ({ commit }, authorization) {
    commit('auth/authorize', authorization)

    await api.user.get(authorization._id)
      .then(({ data }) => commit('auth/authenticate', data))
      .catch(() => commit('auth/clear'))
  },

  async change ({ commit, state }, payload) {
    payload = _.merge({ _id: state.auth.user._id }, payload)

    await api.user.save(payload)
      .then(({ data }) => commit('auth/change', data))
      .catch(({ response }) => commit('auth/error', response.data))
  },

  async check ({ commit }) {
    const _id = localStorage.getItem('_id')

    if (_id) {
      await api.user.get(_id)
        .then(({ data }) => commit('auth/authorize', data))
        .catch(() => commit('auth/unauthorize'))
    }

    commit('auth/checked', true)
  },

  async onboard ({ commit, state }, accountId) {
    return new Promise((resolve, reject) => {
      commit('auth/errorOnOnboard', { message: undefined })
      commit('auth/isOnboardPending', true)

      api.user.post('onboard', { accountId, id: state.auth.user._id })
        .then(({ data }) => {
          commit('auth/authenticate', data)
          commit('auth/onboard', data)
          commit('auth/isOnboardPending', false)

          resolve(data)
        })
        .catch(({ response }) => {
          commit('auth/errorOnOnboard', response.data)
          commit('auth/isOnboardPending', false)

          reject(response.data)
        })
    })
  }
}

export default actions
